import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=723a2ccc&"
import script from "./Star.vue?vue&type=script&lang=js&"
export * from "./Star.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('723a2ccc')) {
      api.createRecord('723a2ccc', component.options)
    } else {
      api.reload('723a2ccc', component.options)
    }
    module.hot.accept("./Star.vue?vue&type=template&id=723a2ccc&", function () {
      api.rerender('723a2ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/Star.vue"
export default component.exports